import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/Layout";
import Seo from "../seo/Seo";
import AboutSection from "../components/home/AboutSection";
import VideoSection from "../components/home/VideoSection";
import MarketPositionSection from "../components/home/MarketPositionSection";
import HeroSection from "../components/home/HeroSection";
import MailingListSection from "../components/home/MailingListSection";
import NewsSection from "../components/home/NewsSection";
import SectionLine from "../components/SectionLine";
import PaddedBlockWithBg from "../components/common/PaddedBlockWithBg";

const HomePage = ({ data }) => {
  const newsData = [...data.news.nodes, ...data.cmsNews.nodes];
  newsData.sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <Layout className="!pt-0">
      <HeroSection
        heroVideoTitle={data.contentfulHomePage.heroVideoTitle}
        heroButtons={data.contentfulHomePage.heroButtons}
        heroLearnMore={data.contentfulHomePage.heroLearnMore}
      />
      <AboutSection
        aboutTitle={data.contentfulHomePage.aboutTitle}
        aboutSubitle={data.contentfulHomePage.aboutSubtitle}
        aboutText={data.contentfulHomePage.aboutText}
        aboutButtonLabel={data.contentfulHomePage.aboutButtonLabel}
        aboutButtonLink={data.contentfulHomePage.aboutButtonLink}
      />
      <SectionLine />
      <MarketPositionSection
        marketPositionTitle={data.contentfulHomePage.marketPositionTitle}
        marketPositionSubtitle={data.contentfulHomePage.marketPositionSubtitle}
        marketPositionText={data.contentfulHomePage.marketPositionText}
        marketPositionItem1Title={data.contentfulHomePage.marketPositionItem1Title}
        marketPositionItem1Description={data.contentfulHomePage.marketPositionItem1Description}
        marketPositionItem2Title={data.contentfulHomePage.marketPositionItem2Title}
        marketPositionItem2Description={data.contentfulHomePage.marketPositionItem2Description}
        marketPositionItem3Title={data.contentfulHomePage.marketPositionItem3Title}
        marketPositionItem3Description={data.contentfulHomePage.marketPositionItem3Description}
        marketPositionItem4Title={data.contentfulHomePage.marketPositionItem4Title}
        marketPositionItem4Description={data.contentfulHomePage.marketPositionItem4Description}
        marketPositionItem5Title={data.contentfulHomePage.marketPositionItem5Title}
        marketPositionItem5Description={data.contentfulHomePage.marketPositionItem5Description}
        marketPositionItem6Title={data.contentfulHomePage.marketPositionItem6Title}
        marketPositionItem6Description={data.contentfulHomePage.marketPositionItem6Description}
      />
      <PaddedBlockWithBg
        backgroundImage={data.contentfulHomePage.presentationImage}
        title={data.contentfulHomePage.presentationTitle}
        text={data.contentfulHomePage.presentationText}
        buttonLabel={data.contentfulHomePage.presentationButtonLabel}
        file={data.presentation?.nodes?.[0]?.file?.url}
      />
      <SectionLine variant="empty" />
      <NewsSection
        newsData={newsData}
        newsInfo={data.contentfulHomePage.newsInfo}
        newsTitle={data.contentfulHomePage.newsTitle}
        newsButtonLabel={data.contentfulHomePage.newsButtonLabel}
        newsButtonLink={data.contentfulHomePage.newsButtonLink}
        readMoreLabel={data.contentfulHomePage.readMoreLabel}
        mostRecentLabel={data.contentfulHomePage.mostRecentNewsTitle}
        mostRecentImage={data.contentfulHomePage.mostRecentNewsImage}
      />
      <SectionLine variant="right" />
      <VideoSection
        videoTitle={data.contentfulHomePage.videoTitle}
        videoSubtitle={data.contentfulHomePage.videoSubtitle}
        videoLink={data.contentfulHomePage.videoLink}
        title={data.contentfulHomePage.videoTitle}
        text={data.contentfulHomePage.videoText}
        buttonLabel={data.contentfulHomePage.videoButtonLabel}
        buttonLink={data.contentfulHomePage.videoButtonLink}
        direction={"left"}
      />
      <MailingListSection />
    </Layout>
  );
};

export const Head = ({ data }) => {
  return <Seo title={data.contentfulHomePage.heroTitle} />;
};

export const query = graphql`
  query HomePageQuery($language: String!) {
    contentfulHomePage(node_locale: { eq: $language }) {
      heroTitle
      heroVideoTitle
      heroButtons {
        label
        link
      }
      heroLearnMore
      aboutTitle
      aboutSubtitle
      aboutText {
        raw
      }
      aboutButtonLabel
      aboutButtonLink
      marketPositionTitle
      marketPositionSubtitle
      marketPositionText {
        raw
      }
      marketPositionItem1Title
      marketPositionItem1Description
      marketPositionItem2Title
      marketPositionItem2Description
      marketPositionItem3Title
      marketPositionItem3Description
      marketPositionItem4Title
      marketPositionItem4Description
      marketPositionItem5Title
      marketPositionItem5Description
      marketPositionItem6Title
      marketPositionItem6Description
      presentationImage {
        gatsbyImageData
        title
      }
      presentationTitle
      presentationText {
        raw
      }
      presentationButtonLabel
      newsTitle
      newsInfo {
        raw
      }
      newsButtonLabel
      newsButtonLink
      mostRecentNewsTitle
      mostRecentNewsImage {
        gatsbyImageData
        title
      }
      videoTitle
      videoSubtitle
      videoText {
        raw
      }
      videoLink
      videoButtonLabel
      videoButtonLink
    }
    presentation: allContentfulPresentation(filter: { node_locale: { eq: $language } }) {
      nodes {
        file {
          url
        }
      }
    }
    news: allNews(limit: 4, sort: { date: DESC }) {
      nodes {
        title
        subTitle
        summary
        image
        date(formatString: "MMMM DD, YYYY")
        ctaLink
      }
    }
    cmsNews: allContentfulNews(filter: { node_locale: { eq: $language } }, limit: 4, sort: { date: DESC }) {
      nodes {
        content {
          raw
        }
        title
        image {
          gatsbyImageData(width: 500)
          title
        }
        date(formatString: "MMMM DD, YYYY")
        ctaLink
      }
    }
  }
`;

export default HomePage;
